export const getNEISUrl = (baseUrl: string) => {
  const neisUrl = `${baseUrl}/neis/schools`
  return {
    GET_SCHOOL_LIST: neisUrl
  }
}
